import App from "@/core/classes/App";

export const appInstance = new App('admin')
export const app = appInstance
